import ShortenedTitle from "components/General-UI/ShortenedTitle";
import { ADMIN_CODE } from "constants/constants";
import React from "react";
import { store } from "Store";
import { leaveEffice, removeAsAdmin } from "slices/peopleSlice";
import { setConfirmationModal } from "slices/textSlice";

const myOptions = ({ setLoading, user_id, permissionsEffice }) => {
  let options = [];
  if (permissionsEffice.role_id === ADMIN_CODE) {
    options = options.concat([
      {
        text: "Stop Being Admin",
        action: () => {
          setLoading(true);
          store
            .dispatch(removeAsAdmin(permissionsEffice.id, user_id))
            .catch(() => setLoading(false)) // adding catch blocks because firefox is saying its an unhandled rejection when its only "finally"
            .finally(() => setLoading(false));
        },
        danger: true,
      },
    ]);
  }
  options = options.concat([
    {
      text: (
        <>
          Leave&nbsp;
          <span className="font-bold private-dark-color">
            {permissionsEffice.content}
          </span>
        </>
      ),
      action: () => {
        store.dispatch(
          setConfirmationModal({
            header: (
              <>
                Leave&nbsp;
                <span className="font-bold">
                  <ShortenedTitle
                    title={permissionsEffice.content}
                    maxChars={50}
                  />
                </span>
                ?
              </>
            ),
            content: (
              <>
                Are you sure you want to leave&nbsp;
                <span className="font-bold private-dark-color">
                  <ShortenedTitle
                    title={permissionsEffice.content}
                    maxChars={50}
                  />
                </span>
                ? You cannot come back unless you are invited. If there are no
                other members it will be deleted as well.
              </>
            ),
            action: () => {
              setLoading(true);
              store
                .dispatch(leaveEffice(permissionsEffice.id))
                .catch(() => setLoading(false))
                .finally(() => setLoading(false));
            },
            danger: true,
          })
        );
      },
      danger: true,
    },
  ]);
  return options;
};

export default myOptions;
